import { __assign } from "tslib";
import React from 'react';
import { line } from 'd3-shape';
export default function LineSeries(_a) {
    var series = _a.series, color = _a.color, xScale = _a.xScale, yScale = _a.yScale, chartAreaClipPath = _a.chartAreaClipPath;
    var commonProps = {
        'aria-hidden': true,
        stroke: color,
        clipPath: "url(#" + chartAreaClipPath + ")"
    };
    if (series.type === 'line') {
        var lineGenerator = line()
            .x(function (d) {
            var x = xScale.d3Scale(d.x) || 0;
            if (xScale.isCategorical()) {
                var offset = Math.max(0, xScale.d3Scale.bandwidth() - 1) / 2;
                x += offset;
            }
            return x;
        })
            .y(function (d) { return yScale.d3Scale(d.y) || 0; });
        // Filter out any data that is not part of the xScale
        var visibleData = series.data.filter(function (_a) {
            var x = _a.x;
            return xScale.d3Scale(x) !== undefined;
        });
        return (React.createElement("path", __assign({}, commonProps, { d: lineGenerator(visibleData) || '' })));
    }
    else {
        var range = xScale.d3Scale.range();
        var y = yScale.d3Scale(series.y);
        return React.createElement("line", __assign({}, commonProps, { x1: range[0], x2: range[1], y1: y, y2: y }));
    }
}
//# sourceMappingURL=line-series.js.map